/**
 * BrandNavigation
 * @description Web component used to a navigation for the brands list, showing/hiding all brands based on their first letter, both in desktop-header and mobile-drawer navigation.
 */

(async () => {
  if (!customElements.get('brand-navigation')) {
    class BrandNavigation extends HTMLElement {
      constructor() {
        super();

        const brandsHeader = this.querySelector('[data-brand-navigation="header"]');
        const brandsList = this.querySelector('[data-brand-navigation="list"]');
        const brandsListItems = brandsList.querySelectorAll(`[data-letter]`);
        const brandsNavHeader = this.querySelector('[data-brand-navigation="nav-header"]');
        const brandsNavCount = this.querySelector('[data-brand-navigation="nav-count"]');

        const is_desktop_menu = this.closest('#header') || false;

        // Loop all navigation letters and see if they have Brands to show
        brandsHeader.querySelectorAll('[data-letter]').forEach((button) => {
          const letter = button.dataset.letter;
          const brands = Array.from(brandsListItems).filter(function (brand) {
            return brand.dataset.letter == letter;
          });

          if (!brands.length) {
            // Hide the letter element if it has no brands to show
            button.parentElement.classList.add('hidden');
          } else {
            // Set the brands count on letter element
            button.dataset.count = brands.length;
          }
        });

        // Catch click on a navigation button
        brandsHeader.addEventListener('click', function (event) {
          if (!event.target.closest('[data-letter ]')) return;
          const button = event.target;
          const letter = button.dataset.letter;
          const count = button.dataset.count;

          // Toggle the active state of all navigation buttons
          brandsHeader.querySelectorAll('[data-letter ]').forEach((button) => {
            button.classList.toggle('text-white', button.dataset.letter == letter);
            button.classList.toggle('bg-primary', button.dataset.letter == letter);
          });

          // Toggle the nr of columns on the desktop brandslist, based on the nr of brands
          if (is_desktop_menu) {
            brandsList.classList.toggle('lg:columns-4', count > 9);
            brandsList.classList.toggle('lg:columns-2', count <= 9);
            brandsList.classList.toggle('md:w-1/2', count <= 9);
          }

          // Show the active letter in the mobile drawer header
          if (brandsNavHeader) {
            brandsNavHeader.innerHTML = letter;
          }

          // Show the nr of brands in the mobile drawer header
          if (brandsNavCount) {
            brandsNavCount.innerHTML = count;
          }

          // Toggle the visibility of all brands
          brandsListItems.forEach((brand) => {
            brand.classList.toggle('hidden', brand.dataset.letter !== letter);
          });
        });

        // Trigger a click on the first visible button in the desktop menu to toggle the visibility of all brands
        if (is_desktop_menu) {
          var buttons = brandsHeader.querySelectorAll('li:not(.hidden)');
          var firstVisibleButton = buttons[0].querySelector('[data-letter]');
          firstVisibleButton.click();
        }
      }
    }

    window.BrandNavigation = BrandNavigation;

    customElements.define('brand-navigation', BrandNavigation);
  }
})();
